<template>
  <div class="ALM-dashboard">
    <iframe :src="ia_alm" frameborder="0" allowfullscreen></iframe>
  </div>
</template>

<script>
export default {
  name: "IAALM",
  data() {
    return {
      // La URL incluye el parámetro kiosk=tv para iniciar en modo kiosk
      ia_alm:
        "https://copilotstudio.microsoft.com/environments/Default-f59ce83e-02c5-4c26-84df-04c3808ee58d/bots/crc9a_asistenteDeFormularios/webchat?__version__=2",
    };
  },
};
</script>

<style scoped>
/* Ajusta el contenedor para que ocupe el alto total de la ventana menos la altura de la navbar */
.ALM-dashboard {
  height: calc(
    100vh - 60px
  ); /* Ajusta "60px" según la altura real de tu navbar */
  width: 100%;
  overflow: hidden;
}

/* El iframe ocupará el 100% del contenedor */
.ALM-dashboard iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
